<template>
  <div class="page__container">
    <div
        class="page__content"
    >
      <div style="width: 100%; padding-top: 30px;">
        <v-icon :size="$vuetify.display.width < 1280 ? 90 : 150" color="#3254B9">update</v-icon>
      </div>
      <div class="page__subtitle">
        Благодарим вас за регистрацию. <br/>Пожалуйста, ожидайте подтверждения.
<!--        <br/>Обращаем Ваше внимание! Время обработки заявки на получение карты увеличено. Приносим извинения за доставленные неудобства!-->
      </div>
<!--      <div class="btn__next" @click="goToNextPage">-->
<!--        <span class="btn__next_text">-->
<!--          завершить регистрацию-->
<!--        </span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapGetters } from "vuex"

export default defineComponent({
  name: "PageWaitApprove",
  computed: {
    names () {
      return names
    },
    pa_names () {
      return pa_names
    },
    ...mapGetters({
      getUserStatus: 'auth/getUserStatus',
    })
  },
  methods: {
    goToNextPage () {
      if (!this.getUserStatus.member) {
        this.$router.push({ name: names.REGISTRATION.PAGE })
      } else if (this.getUserStatus.member && !this.getUserStatus.special_information) {
        this.$router.push({ name: names.REGISTRATION.PAGE })
      } else if (this.getUserStatus.special_information && !this.getUserStatus.special) {
        this.$router.push({ name: names.REGISTRATION_APPROVE.PAGE })
      } else if (this.getUserStatus.agreement) {
        this.$router.push({ name: names.REGISTRATION_APPROVE.PAGE })
      } else {
        this.$router.push({ name: pa_names.MAIN })
      }
    }
  }
})
</script>

<style scoped lang="scss">
.page__container {
  width: 100%;
  padding: 50px;
  margin: 0 auto;
}

.page__content {
  padding: 30px;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
}

.page__subtitle {
  padding-top: 40px;
  margin-bottom: 40px;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 400px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1920px) {
  .btn__next {
    height: 60px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .page__container {
    width: 100%;
    padding: 20px;
    margin: 0 auto;
  }

  .page__content {
    padding: 20px;
    text-align: center;
    border-radius: 5px;
    width: 100%;
    background-color: white;
  }

  .btn__next {
    width: 300px;
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
